import IServletRunner, { IServletOptions, IServletProcess } from './IServletRunner';
import { IFilePath } from '../NativeDevice/fileSystem';

export default class NotImplementedServletRunner implements IServletRunner {
	public run(_entryPoint: IFilePath, _options?: IServletOptions): IServletProcess {
		throw new Error('not implemented');
	}
}
